export default __webpack_public_path__ + "static/media/sports-banner.40292504.png";